(function () {
  window.muzVariantImgFallback = window.muzVariantImgFallback || function (event) {
    var img = event.target || event.srcElement;
    if (!img || img.dataset.fallbackApplied) {
      return;
    }
    img.dataset.fallbackApplied = 'true';

    var fallbackSrc = img.getAttribute('data-fallback-src');
    if (!fallbackSrc) {
      return;
    }

    img.removeAttribute('srcset');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.classList.add('muz-placeholder-active');
    img.src = fallbackSrc;

    var message = img.getAttribute('data-fallback-text');
    if (message && !img.dataset.fallbackMessageAdded) {
      img.dataset.fallbackMessageAdded = 'true';
      var textEl = document.createElement('span');
      textEl.className = 'muz-placeholder-text';
      textEl.textContent = message;
      var wrapper = img.parentNode;
      if (wrapper) {
        wrapper.classList.add('muz-placeholder-wrapper');
        wrapper.appendChild(textEl);
      }
    }
  };
})();
